// extracted by css-extract-rspack-plugin
module.exports =  {"request_permission_modal":"RequestPermission_request_permission_modal__h6zHz","warning_request_access_modal":"RequestPermission_warning_request_access_modal__46xcQ"};